// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditUser_container__vGsGA {
  width: 400px;
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.EditUser_header__v3kb1 {
  display: flex;
  justify-content: space-between;
}

.EditUser_header__v3kb1 h3 {
  margin: 0;
}

.EditUser_header__v3kb1 span {
  cursor: pointer;
}

.EditUser_formElement__lyYJe {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 8px 16px;
}

.EditUser_formElement__lyYJe label {
  color: rgba(27, 31, 59, 0.65);
  font-size: 14px;
}

.EditUser_formElement__lyYJe input {
  border: none;
  background-color: transparent;
  color: #121b3f;
  font-size: 1rem;
}

.EditUser_formElement__lyYJe input:focus {
  outline: none;
}

.EditUser_saveBtn__sopgy {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 0 16px;
  border: none;
  background-color: #3082f6;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.EditUser_saveBtn__sopgy:disabled {
  background-color: #8cb6f1;
  cursor: not-allowed;
}

.EditUser_container__vGsGA form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/editUser/EditUser.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".container {\n  width: 400px;\n  background-color: white;\n  padding: 32px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.header h3 {\n  margin: 0;\n}\n\n.header span {\n  cursor: pointer;\n}\n\n.formElement {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border: 1px solid #ededed;\n  border-radius: 12px;\n  padding: 8px 16px;\n}\n\n.formElement label {\n  color: rgba(27, 31, 59, 0.65);\n  font-size: 14px;\n}\n\n.formElement input {\n  border: none;\n  background-color: transparent;\n  color: #121b3f;\n  font-size: 1rem;\n}\n\n.formElement input:focus {\n  outline: none;\n}\n\n.saveBtn {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  padding: 0 16px;\n  border: none;\n  background-color: #3082f6;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.saveBtn:disabled {\n  background-color: #8cb6f1;\n  cursor: not-allowed;\n}\n\n.container form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EditUser_container__vGsGA`,
	"header": `EditUser_header__v3kb1`,
	"formElement": `EditUser_formElement__lyYJe`,
	"saveBtn": `EditUser_saveBtn__sopgy`
};
export default ___CSS_LOADER_EXPORT___;
